import { render, staticRenderFns } from "./ItemTurnoAjustes.vue?vue&type=template&id=07f308cc&"
import script from "./ItemTurnoAjustes.vue?vue&type=script&lang=js&"
export * from "./ItemTurnoAjustes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports